<template>
    <div id="app">
        <keep-alive :include="cachePage">
            <router-view />
        </keep-alive>
    </div>
</template>
<script>
//缓存的页面
import utils from "@/utils/utils";
let cachePage = ["IndexPage", "CategoryPage", "qrCodePage"];
export default {
    data() {
        return {
            cachePage: cachePage,
        };
    },
    mounted() {},
};
</script>
<style lang="less">
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0 auto;
    max-width: 750px;
    color: #2c3e50;
}
html,
body {
    overflow-y: auto;
    display: block;
    margin: 0 auto;
}
body {
    background-color: #f6f6f6;
}
</style>
